import React, { FC } from 'react';
import { closeButtonOverrides } from '@shared/components/ResponsiveDialog/ResponsiveDialog.styles';
import { Box, CloseButton, Flex, TextV2 } from '@withjoy/joykit';
import { PICKER_TYPES } from '../../PhotoPickerDialog.types';
import { useTranslation } from '@shared/core';

type DialogHeaderProps = Readonly<{
  pickerType: PICKER_TYPES;
  handleClose: () => void;
}>;

export const DialogHeader: FC<DialogHeaderProps> = props => {
  const { pickerType, handleClose } = props;

  const { tq } = useTranslation('photoPickerDialog');

  return (
    <Box
      width="100%"
      paddingX={7}
      paddingBottom={5}
      borderBottom="1px solid"
      borderColor="mono3"
      position="relative"
    >
      <Flex
        alignItems="center"
        height={8}
      >
        <TextV2
          as="h3"
          typographyVariant="hed3"
          color="mono14"
          textAlign="left"
        >
          {pickerType === PICKER_TYPES.ADD_TO_COLLECTION ? tq`Add Photos` : tq`Select Photos`}
        </TextV2>
      </Flex>
      <CloseButton
        overrides={{
          Root: { props: { backgroundColor: 'white', ...closeButtonOverrides.Root?.props, position: 'absolute', top: 0, right: 7, zIndex: 10 } },
          Icon: { props: { ...closeButtonOverrides.Icon?.props } },
        }}
        onClick={handleClose}
        aria-label={'close dialog'}
      />
    </Box>
  );
};
